export default __webpack_public_path__ + "static/uni-dd9c0296f127b15b7f4783617306fe3d.png";